<template>
	<Modal v-model="modalVisible" :width="1200" scrollable class-name="vertical-center-modal"   @on-visible-change="onVisibleChange">
		<p slot="header">
			<span>批量编辑产品说明信息</span>
			<!-- <span 
				style="margin-left:20px;color:blue;">{{productCode}}</span> -->
		</p>
		<Loading :isLoading="saveLoading" />
		<Tabs  :animated="false" :capture-focus="true"  v-model="editType">
			<TabPane label="产品列表" name="productInfo">
          
				<productPopupEditTabBathProductList  ref="productPopupEdit"  @chang-template-product="setProductUuid"
					 />
			</TabPane>
			<TabPane v-if="hasTemplateProduct"  :label="getNameByTabtype('productDesInfopOtherSpec')"   name="productDesInfopOtherSpec">
				<Row justify="center"  class="quillRow">
					<Col span="20" offset="2">
					<quill-upload  v-model="productForm.productDesInfopOtherSpec" :uploadImgUrl="uploadImgUrlWithPath" :uploadData="getUploadData('productDesInfopOtherSpec')"  :qillHeight="qillHeight"></quill-upload>
					<!-- <div style="text-align: right;margin-right: 20px;margin-top: 80px;">
						<ButtonGroup>
							<Button v-if="this.$checkAccessArray(['B', 'C'])" type="primary"
								@click="ontherSpecSubmit">保存</Button>
						</ButtonGroup>
					</div> -->
					</Col>
				</Row>
			</TabPane>
			<TabPane v-if="hasTemplateProduct"  :label="getNameByTabtype('productDesInffeatures')" name="productDesInffeatures">
				<Row justify="center" class="quillRow">
					<Col span="20" offset="2">
					<quill-upload  v-model="productForm.productDesInffeatures"  :uploadImgUrl="uploadImgUrlWithPath" :uploadData="getUploadData('productDesInffeatures')"  :qillHeight="qillHeight"></quill-upload>
					</Col>
				</Row>
				<Row justify="center">					
				</Row>
			</TabPane>
			<TabPane v-if="hasTemplateProduct"  :label="getNameByTabtype('productDesInfoCultivation')" name="productDesInfoCultivation">
				<Row justify="center" class="quillRow">
					<Col span="20" offset="2">
					<quill-upload v-model="productForm.productDesInfoCultivation"  :uploadImgUrl="uploadImgUrlWithPath" :uploadData="getUploadData('productDesInfoCultivation')"  :qillHeight="qillHeight"></quill-upload>
					<!-- <div style="text-align: right;margin-right: 20px;margin-top: 80px;">
						<ButtonGroup>
							<Button v-if="this.$checkAccessArray(['B', 'C'])" type="primary"
								@click="onCultivationSubmit">保存</Button>
						</ButtonGroup>
					</div> -->
					</Col>
				</Row>
			</TabPane>
			<TabPane v-if="hasTemplateProduct"  :label="getNameByTabtype('productDesInfoCommonProblem')"  name="productDesInfoCommonProblem">
				<Row justify="center" class="quillRow">
					<Col span="20" offset="2">
					<quill-upload  v-model="productForm.productDesInfoCommonProblem" :uploadImgUrl="uploadImgUrlWithPath" :uploadData="getUploadData('productDesInfoCommonProblem')" :qillHeight="qillHeight"></quill-upload>
					<!-- <div style="text-align: right;margin-right: 20px;margin-top: 80px;">
						<ButtonGroup>
							<Button v-if="this.$checkAccessArray(['B', 'C'])" type="primary"
								@click="onCommonProblemSubmit">保存</Button>
						</ButtonGroup>
					</div> -->
					</Col>
				</Row>
			</TabPane>
			<TabPane v-if="hasTemplateProduct" :label="getNameByTabtype('productDesInfoafterService')" name="productDesInfoafterService">
				<Row justify="center" class="quillRow">
					<Col span="20" offset="2">
					<quill-upload  v-model="productForm.productDesInfoafterService"  :uploadImgUrl="uploadImgUrlWithPath" :uploadData="getUploadData('productDesInfoafterService')" :qillHeight="qillHeight"></quill-upload>
					<!-- <div style="text-align: right;margin-right: 20px;margin-top: 80px;">
						<ButtonGroup>
							<Button v-if="this.$checkAccessArray(['B', 'C'])" type="primary"
								@click="onproductDesInfoafterServiceSubmit">保存</Button>
						</ButtonGroup>
					</div> -->
					</Col>
				</Row>
			</TabPane>
			<TabPane v-if="hasTemplateProduct" :label="getNameByTabtype('productDesInfodiscountPolicy')" name="productDesInfodiscountPolicy">
				<Row justify="center" class="quillRow">
					<Col span="20" offset="2">
					<quill-upload   v-model="productForm.productDesInfodiscountPolicy"  :uploadImgUrl="uploadImgUrlWithPath" :uploadData="getUploadData('productDesInfodiscountPolicy')" :qillHeight="qillHeight"></quill-upload>
					<!-- <div style="text-align: right;margin-right: 20px;margin-top: 80px;">
						<ButtonGroup>
							<Button v-if="this.$checkAccessArray(['B', 'C'])" type="primary"
								@click="onproductDesInfodiscountPolicySubmit">保存</Button>
						</ButtonGroup>
					</div> -->
					</Col>
				</Row>
			</TabPane>
			<TabPane v-if="hasTemplateProduct" :label="getNameByTabtype('productDesInfoPdfLinkList')" name="productDesInfoPdfLinkList">
				<Row justify="center" class="quillRow">
					<Col span="20" offset="2">
					<pdf-upload  :productUuid="productUuid" v-model="productForm.productDesInfoPdfLinkList"  :uploadData="getUploadData('productDesInfoPdfLinkList')" :qillHeight="qillHeight"></pdf-upload>
					</Col>
				</Row>
			</TabPane>
			<TabPane v-if="hasTemplateProduct" :label="getNameByTabtype('productDesInfoDiseasePestControl')" name="productDesInfoDiseasePestControl">
				<Row justify="center" class="quillRow">
					<Col span="20" offset="2">
					<quill-upload   v-model="productForm.productDesInfoDiseasePestControl" :uploadImgUrl="uploadImgUrlWithPath" :uploadData="getUploadData('productDesInfoDiseasePestControl')" :qillHeight="qillHeight"></quill-upload>
					</Col>
				</Row>
			</TabPane>
			<TabPane v-if="hasTemplateProduct" :label="getNameByTabtype('productDesInfoPostHarvestProcessing')" name="productDesInfoPostHarvestProcessing">
				<Row justify="center" class="quillRow">
					<Col span="20" offset="2">
					<quill-upload   v-model="productForm.productDesInfoPostHarvestProcessing" :uploadImgUrl="uploadImgUrlWithPath" :uploadData="getUploadData('productDesInfoPostHarvestProcessing')"  :qillHeight="qillHeight"></quill-upload>
					</Col>
				</Row>
			</TabPane>
		</Tabs>
		<div slot="footer">		
			<Button v-if="this.$checkAccessArray(['B', 'C'])&&editType!='productInfo'" type="primary"
			@click="saveListProductDescriptiveInformationSingleAttribute">{{'保存'+getNameByTabtype(editType)}}</Button>
			<Button v-if="this.$checkAccessArray(['B', 'C'])" type="primary"
			@click="saveListProductDescriptiveInformation">保存说明信息</Button>
		</div>
	</Modal>
</template>

<script>

import Loading from '@/components/loading/Loading.vue';
import ProductPopupEdit from './product-popup-edit-new';
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from '@/view/mixins/form-edit-mode';
import {
    getProductDescriptiveInformation,
    saveProductListDescriptiveInformation,
    saveProductListDescriptiveInformationSingleAttribute
} from '@/api/modules/product-management/productApprove-management';
import { UPLOAD_FILE_API_PATH, FILE_SERVER } from '@/api/modules/files';


import ModalVisible from '@/view/mixins/modal-visible';
import quillUpload from '@/components/quill-upload/quill-upload.vue';
import pdfUpload from './product-popup-edit-pdfUpload.vue';

import productPopupEditTabBathProductList from './product-popup-edit-Tab-Bath-ProductList';


export default {
    name: 'ProductPopupEditTabBath',
    components: {
        ProductPopupEdit,
        quillUpload,
        Loading,
        pdfUpload,
        productPopupEditTabBathProductList
    },
    mixins: [ModalVisible],
    props: {
        // productUuid: {
        // 	type: String,
        // 	default: ''
        // },
        productUuidsBathEdit: {
            type: Array,
            default: function () {
                return [];
            }
        },
        // productCode: {
        // 	type: String,
        // 	required: true,
        // 	default: ''
        // },
        // formEditMode:{
        // 		type: String,
        // 		required: true,
        // 		default: FORM_EDIT_MODE_MODIFY
        // 	},
        popupEditResource: {
            type: Object,
            required: true,
            default() {
                return {
                    seedFarmCode: '',
                    mainCategorySource: [],
                    rawSubCategorySource: [],
                    brandSource: [],
                    serialSource: [],
                    unitSource: [],
                    packageSource: [],
                    masterSource: [],
                    allRegionInfo: [],
                    approvalSource: [],
                    packingFee: '',
                    deliveryFee: '',
                    // productCategoryFeature: '',
                    productDesInfoCultivation: 0,
                    demonstrationVideo2: 0,
                    demonstrationVideo3: 0,
                    demonstrationVideo4: 0,
                    demonstrationVideo5: 0,
                    productDesInfodiscountPolicy: 0,
                    productPreSaleDiscountRatio: 0,
                    productFeatureContract: '',
                    pottingSeedling: 0,
                    seedlingHeight: '',
                    leavesNumber: ''
                };
            }
        }
    },
    data() {
        return {
            qillHeight:440,
            popupEditModalShow: false,
            productUuid:'',
            editType: 'productInfo',			
            uploadImgUrlWithPath: 'https://up-z2.qiniup.com/',
            FILE_SERVER,
            //formEditMode: this.productUuid ?FORM_EDIT_MODE_MODIFY:FORM_EDIT_MODE_CREATE,				
            productForm: {
                productDesInfopOtherSpec: '',
                productDesInffeatures: '',
                productDesInfoCultivation: '',
                productDesInfoCommonProblem: '',
                productDesInfoafterService: '',
                productDesInfodiscountPolicy: '',
                productDesInfoPdfLinkList: '',
                productDesInfoDiseasePestControl: '',
                roductDesInfoPostHarvestProcessing: ''
            },
            saveLoading:false
        };
    },
    watch: {
        productUuid: function (newValue, oldVaule) {			
            if (newValue) {
                this.getProductDescriptiveInformation(this.productUuid);
            }
            else {
                this.clearProductDescriptiveInformation();
            }
        }
    },
    methods: {
        getNameByTabtype(editType){
            switch (editType) {
                case 'productInfo':
                    return '';
                case 'productDesInfopOtherSpec':
                    return '特别通告';
                case 'productDesInffeatures':
                    return '品种介绍';
                case 'productDesInfoCultivation':
                    return '栽培技术';
                case 'productDesInfoCommonProblem':
                    return '常见问题';
                case 'productDesInfoafterService':
                    return '关于售后';
                case 'productDesInfodiscountPolicy':
                    return '优惠政策';
                case 'productDesInfoPdfLinkList':
                    return 'PDF目录';
                case 'productDesInfoDiseasePestControl':
                    return '病虫防治';
                case 'productDesInfoPostHarvestProcessing':
                    return '采后处理';
            }
        },
        saveListProductDescriptiveInformationSingleAttribute(){
            let checkDate=this.saveBeforeCheck();
			
            if(!checkDate.code){
                return;
            }
            let productList=checkDate.productList;
            let data={
                AttributeName:this.editType,
                AttibuteValue:this.productForm[this.editType],
                productUuidList:productList
            };
		
            this.saveLoading=true;
            saveProductListDescriptiveInformationSingleAttribute(data).then(res=>{
                this.saveLoading=false;
                if(res.code==0){			
                    this.$Message.info(this.getNameByTabtype(this.editType)+'保存成功');
                }
                else{
                    this.$Message.info(res.message);
                }
            });
        },
        getUploadData(path){
            let uploadData={};
            if(this.productUuid){
                uploadData.updatePath=`${path}/`+this.productUuid;
            }
            else{
                uploadData.updatePath=`${path}`;
            }
            return uploadData;       
        },
        setProductUuid(productUuid){
            this.productUuid=productUuid;
        },
        onVisibleChange(view) {
            if (view) {
                this.editType='productInfo';
                //     let productUuids=['be561798-38f9-45c9-af3e-0ecd5cca482e'];
				 this.$refs.productPopupEdit.init(this.productUuidsBathEdit);
                // this.getProductDescriptiveInformation(this.productUuid);
            }
        },
        getProductDescriptiveInformation(productUuid){
            getProductDescriptiveInformation(productUuid).then(res=>{
                if(res.code==0){
                    this.productForm.productDesInfopOtherSpec = res.data.productDesInfopOtherSpec;
                    this.productForm.productDesInffeatures = res.data.productDesInffeatures;
                    this.productForm.productDesInfoCultivation = res.data.productDesInfoCultivation;
                    this.productForm.productDesInfoCommonProblem = res.data.productDesInfoCommonProblem;
                    this.productForm.productDesInfoafterService = res.data.productDesInfoafterService;
                    this.productForm.productDesInfodiscountPolicy = res.data.productDesInfodiscountPolicy;
                    this.productForm.productDesInfoPdfLinkList = res.data.productDesInfoPdfLinkList;
                    this.productForm.productDesInfoDiseasePestControl = res.data.productDesInfoDiseasePestControl;
                    this.productForm.productDesInfoPostHarvestProcessing = res.data.productDesInfoPostHarvestProcessing;
                }
            });
        },
        clearProductDescriptiveInformation(productUuid) {
            this.productForm.productDesInfopOtherSpec = '';
            this.productForm.productDesInffeatures = '';
            this.productForm.productDesInfoCultivation = '';
            this.productForm.productDesInfoCommonProblem = '';
            this.productForm.productDesInfoafterService ='';
            this.productForm.productDesInfodiscountPolicy = '';
            this.productForm.productDesInfoPdfLinkList ='';
            this.productForm.productDesInfoDiseasePestControl = '';
            this.productForm.productDesInfoPostHarvestProcessing = '';

        },
        basicInformationubmit(){
            this.$refs.productPopupEdit.onSubmit();
        },
        saveListProductDescriptiveInformation(){
            // if(!this.productUuid){
            // 	this.$Message.warning('产品模板不能为空,请选择产品模板');
            // 	return;
            // }
            // let productList= this.$refs.productPopupEdit.mainTable.tableData.map(item=>item.productUuid);
            // if(productList.length==0){
            // 	this.$Message.warning('要修改的条数不能为0！');
            // 	return;
            // }
            let checkDate=this.saveBeforeCheck();
            if(!checkDate.code){
                return;
            }
            let productList=checkDate.productList;
            let data=Object.assign({}, this.productForm, { productUuidList:productList });
            this.saveLoading=true;
            saveProductListDescriptiveInformation(data).then(res=>{
                this.saveLoading=false;
                if(res.code==0){			
                    this.$Message.info('所有说明信息保存成功');
                }
                else{
                    this.$Message.info(res.message);
                }
            });
        },
        saveBeforeCheck(){
            let result={ code:true, productList:[] };
            if(!this.productUuid){
                this.$Message.warning('产品模板不能为空,请选择产品模板');
                result.code=false;
                return result;
            }
            let productList= this.$refs.productPopupEdit.mainTable.tableData.map(item=>item.productUuid);
            if(productList.length==0){
                this.$Message.warning('要修改的条数不能为0！');
                result.code=false;
                return result;
            }
            result.productList=productList;
            return result;
        }
    },
	
    computed:{
        hasTemplateProduct(){
            return this.productUuid?true:false;
        }
    }
};
</script>

<style lang="less">
 .quillRow{
	margin:30px 0px 50px 0px;
 }
</style>
